import ActionFormRow from './ActionFormRow'
import DropDownFormRow from './DropDownFormRow'
import FormRow from './FormRow'
import InputFormRow, { InputFormRowProps } from './InputFormRow'
import TextFieldFormRow from './TextFieldFormRow'

const FormComponent = {
  ActionFormRow,
  DropDownFormRow,
  FormRow,
  InputFormRow,
  TextFieldFormRow,
}

export type { InputFormRowProps }
export default FormComponent
